import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { TabsModule } from 'ngx-bootstrap/tabs'
import { HttpClientModule, HttpClient } from '@angular/common/http';
//import { NgxIntlTelInputModule } from 'intl-tel-input';
//import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
//import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { RegisterComponent } from './front-user/common-features/registration/register.component';
import { AlertComponent } from './shared/components/alert/alert.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { AppConfig } from './shared/services/app.config';
import { LoginComponent } from './front-user/common-features/login/login.component';
import { UserProfileComponent } from './front-user/common-features/user-profile/user-profile.component';
import { WorkspaceComponent } from './front-user/common-features/workspace/workspace.component';
import { SignOutComponent } from './front-user/common-features/sign-out/sign-out.component';
import { ResetPasswordComponent } from './front-user/common-features/reset-password/reset-password.component';
import { ChangePasswordComponent } from './front-user/common-features/change-password/change-password.component';
import { ForgetPasswordComponent } from './front-user/common-features/forget-password/forget-password.component';
import { RebateRequestComponent } from './front-user/services/long-haul/rebate-request/rebate-request.component';
import { RebateRequestConfirmReceivingRequestComponent } from './admin/e-services/long-haul/rebate-request-confirm-receiving-request/rebate-request-confirm-receiving-request.component';
import { RebateRequestMeasurementCommitteeDecisionComponent } from './admin/e-services/long-haul/rebate-request-measurement-committee-decision/rebate-request-measurement-committee-decision.component';
import { CircularRequestAdminDecisionComponent } from './admin/e-services/Circulars/circular-request-admin-decision/circular-request-admin-decision.component';
import { CookieService } from 'ngx-cookie-service';
import { CreateRepairRequestComponent } from './front-user/shipyard-service/components/create-repair-request/create-repair-request.component';
import { SalvageRequestComponent } from './front-user/shipyard-service/components/salvage-request/salvage-request.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { StyleGuideComponent } from './front-user/style-guide/style-guide.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CreateFloatingCranesRequestComponent } from './front-user/shipyard-service/components/create-floating-cranes-request/create-floating-cranes-request.component';
import { AgentRegistrationComponent } from './front-user/services/e-booking/agent-registration/agent-registration.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NonDestructiveTestingWorkComponent } from './front-user/shipyard-service/components/quality-request/non-destructive-testing-work/non-destructive-testing-work.component';
import { DynamicBalancingRequestComponent } from './front-user/shipyard-service/components/quality-request/dynamic-balancing-request/dynamic-balancing-request.component';
import { UserRequestDetailsComponent } from './front-user/shared/components/user-request-details/user-request-details.component';
import { FibberglassRequestComponent } from './front-user/shipyard-service/components/fibberglass-request/fibberglass-request.component';
import { CreateHardnessTestRequestComponent } from './front-user/shipyard-service/components/quality-request/create-hardness-test-request/create-hardness-test-request.component';
import { AgentBasicInfoComponent } from './front-user/services/e-booking/agent-basic-info/agent-basic-info.component';
import { GridViewComponent } from './shared/components/grid-view/grid-view.component';
import { TestComponent } from './test/test.component';
import { AdminDecisionComponent } from './front-user/shipyard-service/components/admin-decision/admin-decision.component';
import { AdditionalWorkComponent } from './front-user/shipyard-service/components/additional-work/additional-work.component';
import { FeesEstimationRequestComponent } from './front-user/services/e-booking/fees-estimation-request/fees-estimation-request.component';
//import { Ng2TableModule } from 'ngx-datatable/ng2-table';
import { DatePipe } from '@angular/common';
import { ConfirmAccountComponent } from './front-user/common-features/confirm-account/confirm-account.component';
import { ActivateAccountComponent } from './front-user/common-features/activate-account/activate-account.component';
import { WorkCompletionFormComponent } from './front-user/shipyard-service/components/work-completion-form/work-completion-form.component';
import { RegistrationAdminDecisionComponent } from './admin/e-services/e-booking/agent-registration-request/registration-admin-decision/registration-admin-decision.component';
import { FibberglassContractComponent } from './front-user/shipyard-service/components/fibberglass-contract/fibberglass-contract.component';
import { FibberglassOfflinePaymentComponent } from './front-user/shipyard-service/components/fibberglass-offline-payment/fibberglass-offline-payment.component';
import { MyTasksComponent } from './shared/components/my-tasks/my-tasks.component';
import { ReleaseTasksComponent } from './shared/components/release-tasks/release-tasks.component';
import { AllServicesComponent } from './front-user/services/all-services/all-services.component';
import { InvalidForgetpasswordLinkComponent } from './front-user/common-features/invalid-forgetpassword-link/invalid-forgetpassword-link.component';
import { ConfimPaymentComponent } from './admin/e-services/e-booking/agent-registration-request/confim-payment/confim-payment.component';
import { EnterEachCurrencyComponent } from './admin/e-services/e-booking/agent-registration-request/enter-each-currency/enter-each-currency.component';
import { UserDecisionComponent } from './front-user/shipyard-service/components/user-decision/user-decision.component';
import { RequestDetailsComponent } from './shared/components/request-details/request-details.component';
import { OfflineAgentRegistrationComponent } from './admin/e-services/e-booking/agent-registration-request/offline-agent-registration/offline-agent-registration.component';
import { RebateRequestDefineRebateComponent } from './admin/e-services/long-haul/rebate-request-define-rebate/rebate-request-define-rebate.component';
import { MeasurementsReviewerDecisionComponent } from './admin/e-services/e-booking/fees-estimation-request/measurements-reviewer-decision/measurements-reviewer-decision.component';
import { MeasurementOfficerFeesComponent } from './admin/e-services/e-booking/fees-estimation-request/measurement-officer-fees/measurement-officer-fees.component';
import { MeasurementOfficerFeesComponentNew } from './admin/e-services/e-booking/fees-estimation-request/measurement-officer-fees-new/measurement-officer-fees-new.component';
import { MarineOfficerFeesComponent } from './admin/e-services/e-booking/fees-estimation-request/marine-officer-fees/marine-officer-fees.component';
import { ManagerConfirmFeesComponent } from './admin/e-services/e-booking/fees-estimation-request/manager-confirm-fees/manager-confirm-fees.component';
import { ManagerConfirmFeesComponentNew } from './admin/e-services/e-booking/fees-estimation-request/manager-confirm-fees-new/manager-confirm-fees-new.component';
import { UpdateAgentProfileComponent } from './front-user/services/e-booking/update-agent-profile/update-agent-profile.component';
import { RegisterAdminDecisionComponent } from './admin/e-services/e-booking/update-agent-profile-request/register-admin-decision/register-admin-decision.component';
import { RebateRequestReviewRebateComponent } from './admin/e-services/long-haul/rebate-request-review-rebate/rebate-request-review-rebate.component';
import { UnauthorizedUserComponent } from './shared/components/unauthorized-user/unauthorized-user.component';
import { OfflineAgentListComponent } from './admin/e-services/e-booking/agent-registration-request/offline-agent-list/offline-agent-list.component';
import { ActivateAgentComponent } from './admin/e-services/e-booking/agent-registration-request/activate-agent/activate-agent.component';
import { DeacitvateAgentComponent } from './admin/e-services/e-booking/agent-registration-request/deacitvate-agent/deacitvate-agent.component';
import { ActivateAgentRepresentativeComponent } from './front-user/services/e-booking/activate-agent-representative/activate-agent-representative.component';
import { DeactivateAgentRepresentativeComponent } from './front-user/services/e-booking/deactivate-agent-representative/deactivate-agent-representative.component';
import { AgentRepresentativeListComponent } from './front-user/services/e-booking/agent-representative-list/agent-representative-list.component';
import { MyRequestsComponent } from './shared/components/my-requests/my-requests.component';
import { MyRequestsWithVesselNameComponent } from './shared/components/my-requests-withVesselName/my-LC-requests.component';
import { RequestHistoryComponent } from './shared/components/request-History/request-history.component';
import { MessageComponent } from './shared/components/messaging/message/message.component';
import { MyMessagesComponent } from './shared/components/messaging/my-messages/my-messages.component';
import { MyUnreadMessagesComponent } from './shared/components/messaging/my-Unreadmessages/my-Unreadmessages.component';
import { AllMessagesComponent } from './shared/components/messaging/all-messages/all-messages.component';
import { ETenderMessagesComponent } from './shared/components/messaging/etender-messages/etender-messages.component';
import { RebateRequestFormulatdDecisionComponent } from './admin/e-services/long-haul/rebate-request-formulatd-decision/rebate-request-formulatd-decision.component';
import { ShipyardReportComponent } from './front-user/shipyard-service/components/shipyard-report/shipyard-report.component';
import { SupplierRegistrationComponent } from './front-user/services/e-tender/supplier-registration/supplier-registration.component';
import { RebateRequestRequestorDecisionComponent } from './front-user/services/long-haul/rebate-request-requestor-decision/rebate-request-requestor-decision.component';
import { CircularRequestRequestorDecisionComponent } from './front-user/services/Circulars/Circular-request-requestor-decision/Circular-request-requestor-decision.component';
import { ActivateAgentWithDeactivationDateComponent } from './admin/e-services/e-booking/agent-registration-request/activate-agent-with-deactivation-date/activate-agent-with-deactivation-date.component';
import { SupplierBidSubsriptionComponent } from './front-user/services/e-tender/components/supplier-bid-subsription/supplier-bid-subsription.component';
import { CreateTenderComponent } from './admin/e-services/e-tender/create-tender/create-tender.component';
import { EBookingReportComponent } from './shared/components/ebooking-report/ebooking-report.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { BidSupplierSubscriptionListComponent } from './admin/e-services/e-tender/bid-supplier-subscription-list/bid-supplier-subscription-list.component';
import { FeesEstimationDetailsComponent } from './front-user/services/e-booking/fees-estimation-details/fees-estimation-details.component';
import { TransitRequestComponent } from './front-user/services/e-booking/transit-request/transit-request.component';
import { AccurateDataFormComponent } from './admin/e-services/long-haul/accurate-data-form/accurate-data-form.component';
import { ChangeRebateFormComponent } from './admin/e-services/long-haul/change-rebate-form/change-rebate-form.component';
import { ConfirmShipPassingComponent } from './admin/e-services/long-haul/confirm-ship-passing/confirm-ship-passing.component';
import { MarkRequestRefundedComponent } from './admin/e-services/long-haul/mark-request-refunded/mark-request-refunded.component';
import { MarineAcceptTransitDateComponent } from './admin/e-services/e-booking/transit-request/marine-accept-transit-date/marine-accept-transit-date.component';
import { MarineOfficerReviewComponent } from './admin/e-services/e-booking/transit-request/marine-officer-review/marine-officer-review.component';
import { MarineOfficerconfirmationComponent } from './admin/e-services/e-booking/transit-request/marine-officer-confirmation/marine-officer-confirmation.component';
import { AgentApprovalLimittimeRateComponent } from './admin/e-services/e-booking/transit-request/Agent-Approval-Limit-time-Rate/Agent-Approval-Limit-time-Rate.component';
import { EbookingAccurateDataComponent } from './admin/e-services/e-booking/transit-request/ebookingAccuarteData/ebooking-Accuarte-Data.component';
import { EtenderEvaluationComponent } from './admin/e-services/e-tender/etender-evaluation/etender-evaluation.component';
import { SupplierListComponent } from './admin/e-services/e-tender/supplier-list/supplier-list.component';
import { TenderListComponent } from './admin/e-services/e-tender/tender-list/tender-list.component';
import { RebateRequestsManagementComponent } from './admin/e-services/long-haul/rebate-requests-management/rebate-requests-management.component';
import { RebateRequestRequestDetailsComponent } from './admin/e-services/long-haul/rebate-request-request-details/rebate-request-request-details.component';
import { CircularRequestBaseRequestDetailsComponent } from './front-user/services/Circulars/Circular-request-base-request-details/Circular-request-base-request-details.component';
import { MarineMarkVesselArrivedComponent } from './admin/e-services/e-booking/transit-request/marine-mark-vessel-arrived/marine-mark-vessel-arrived.component';
import { TreasuryConfirmFirstPaymentComponent } from './admin/e-services/e-booking/transit-request/treasury-confirm-first-payment/treasury-confirm-first-payment.component';
import { MeasurementExtraFeesComponent } from './admin/e-services/e-booking/transit-request/measurement-extra-fees/measurement-extra-fees.component';
import { DeactivateSupplierComponent } from './admin/e-services/e-tender/deactivate-supplier/deactivate-supplier.component';
import { TreasuryConfirmFinalPaymentComponent } from './admin/e-services/e-booking/transit-request/treasury-confirm-final-payment/treasury-confirm-final-payment.component';
import { MeasurementConfirmPendingDocumentsComponent } from './admin/e-services/e-booking/transit-request/measurement-confirm-pending-documents/measurement-confirm-pending-documents.component';
import { RebateRequestBaseRequestDetailsComponent } from './admin/e-services/long-haul/rebate-request-base-request-details/rebate-request-base-request-details.component';
import { FileValueAccessor } from './front-user/shared/validator/file-control-value-accessor';
import { OnlyDecimalDirective } from './shared/directives/only-decimal.directive';
import { ConfirmationDirective } from './shared/directives/confirmation.directive';
import { FileValidator } from './front-user/shared/validator/file-input.validator';
import { CancelTenderComponent } from './admin/e-services/e-tender/cancel-tender/cancel-tender.component';
import { DeleteTenderComponent } from './admin/e-services/e-tender/delete-tender/delete-tender.component';
import { DefineTenderDeadlineComponent } from './admin/e-services/e-tender/define-tender-deadline/define-tender-deadline.component';
import { ViewTenderComponent } from './admin/e-services/e-tender/view-tender/view-tender.component';
import { SupplierRatingComponent } from './admin/e-services/e-tender/supplier-rating/supplier-rating.component';
import { EtenderSupplierEvaluationListComponent } from './admin/e-services/e-tender/etender-supplier-evaluation-list/etender-supplier-evaluation-list.component';
import { SupplierRegistrationAprovalComponent } from './admin/e-services/e-tender/supplier-registration-approvals/supplier-registration-aproval/supplier-registration-aproval.component';
import { PurchasingCategoryAdminAprovalComponent } from './admin/e-services/e-tender/supplier-registration-approvals/purchasing-category-admin-aproval/purchasing-category-admin-aproval.component';
import { TechnicalCategoryAdminAprovalComponent } from './admin/e-services/e-tender/supplier-registration-approvals/technical-category-admin-aproval/technical-category-admin-aproval.component';
import { SupplierRegistrationActivateComponent } from './admin/e-services/e-tender/supplier-registration-activate/supplier-registration-activate.component';
import { LongHaulReportComponent } from './admin/e-services/long-haul/long-haul-report/long-haul-report.component';
import { SupplierTenderListComponent } from './admin/e-services/e-tender/supplier-tender-list/supplier-tender-list.component';
import { TenderComponent } from './admin/e-services/e-tender/tender/tender.component';
import { RebateRequestCloneRequestComponent } from './front-user/services/long-haul/rebate-request-clone-request/rebate-request-clone-request.component';
import { CircularRequestCloneRequestComponent } from './front-user/services/Circulars/circular-request-clone-request/circular-request-clone-request.component';
import { TenderViewAllFieldsComponent } from './admin/e-services/e-tender/tender-view-all-fields/tender-view-all-fields.component';
import { ActivateAgentTreasuryNumbersComponent } from './admin/e-services/e-booking/agent-registration-request/activate-agent-treasury-numbers/activate-agent-treasury-numbers.component';
import { EnterTreasuryNumbersComponent } from './admin/e-services/e-booking/update-agent-profile-request/enter-treasury-numbers/enter-treasury-numbers.component';
import { InviteAdditionalSupplierComponent } from './admin/e-services/e-tender/invite-additional-supplier/invite-additional-supplier/invite-additional-supplier.component';
import { EntranceRequestComponent } from './front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsTransitRequestComponent } from './front-user/services/small-units/transit-request/transit-request.component';
import { MeasurementEstimateFeesComponent } from './admin/e-services/small-units/measurement-Estimate-fees/measurement-Estimate-fees-component';
import { SmallUnitsReviewRequestComponent } from './admin/e-services/small-units/review-request/review-request-component';
import { ConfirmArrivalComponent } from './admin/e-services/small-units/marine-confirm-Arrival/marine-confirm-Arrival-component';
import { RegisterMeasurmentComponent } from './admin/e-services/small-units/register-measurment/register-measurment.component';
import { ConfirmPaymentComponent } from './admin/e-services/small-units/confirm-payment/confirm-payment-component';
import { SmallUnitsConfirmDocumentComponent } from './admin/e-services/small-units/SmallUnits-Confirm-Document/SmallUnits-Confirm-Document-component'
import { ReviewTransitRequestComponent } from './admin/e-services/small-units/Review-Transit-Request/review-transit-request-component';
import { TransitApprovalComponent } from './admin/e-services/small-units/Transit-Approval/transit-approval-component';
import { ConfirmTransitComponent } from './admin/e-services/small-units/confirm-transit/confirm-transit-component'
import { FinalFeesComponent } from './admin/e-services/small-units/Final-Fees/final-fees-component'
import { SmallUnitsTasksComponent } from './shared/components/SmallUnits-tasks/SmallUnits-tasks.component';
import { CircularsTasksComponent } from './shared/components/circulars/Circulars-tasks.component';
import { ChangeCrewTasksComponent } from './shared/components/ChangeCrew/ChangeCrew-tasks.component';
import { SmallUnitsReportComponent } from './admin/e-services/small-units/small-units-report/small-units-report.component';
import { CrewChangeReportComponent } from './admin/e-services/CrewChange/CrewChange-report/CrewChange-report.component';
import { CircularRequestComponent } from './front-user/services/Circulars/circular-request/circular-request.component';
import { CircularsReportsComponent } from './admin/e-services/Circulars/circulars-reports/circulars-reports.component';
import { CircularsConfirmShipPassingComponent } from './admin/e-services/Circulars/confirm-ship-passing/circulars-confirm-ship-passing.component';
import { CircularsRefundCloseComponent } from './admin/e-services/Circulars/circulars-refund-close/circulars-refund-close.component';
import { CicularRequestorrejectionNotificationComponent } from './admin/e-services/Circulars/cicular-requestor-rejection-notification/cicular-requestor-rejection-notification.component';
import { CircularTasksDirectoryComponent } from './admin/e-services/Circulars/Circular-tasks-directory/Circular-tasks-directory-compnent';
import { CircularRequestDetailsComponent } from './admin/e-services/Circulars/circular-request-request-details/circular-request-request-details.component';
import { CircularsConfirmCancelComponent } from './admin/e-services/Circulars/circulars-confirm-cancel/circulars-confirm-cancel.component';
import { CircularsCancelRequestComponent } from './front-user/services/Circulars/circulars-cancel-request/circulars-cancel-request.component';
import { IsmConfirmArrivalComponent } from './admin/e-services/small-units/ism-confirm-arrival/ism-confirm-arrival.component';
import { IsmRequestDepartureComponent } from './admin/e-services/small-units/ism-request-departure/ism-request-departure.component';
import { IsmDepartureApprovalComponent } from './admin/e-services/small-units/ism-departure-approval/ism-departure-approval.component';
import { IsmConfirmTransitComponent } from './admin/e-services/small-units/ism-confirm-transit/ism-confirm-transit.component';
import { CrewChangeRequestComponent } from './front-user/services/CrewChange/crew-change-request/crew-change-request.component';
import { CrewchangeReviewerDecisionComponent } from './admin/e-services/CrewChange/crewchange-reviewer-decision/crewchange-reviewer-decision.component';
import { CrewchangeApprovalDecisionComponent } from './admin/e-services/CrewChange/crewchange-approval-decision/crewchange-approval-decision.component';
import { CrewChangeAgentApprovalComponent } from './front-user/services/CrewChange/crew-change-agent-approval/crew-change-agent-approval.component';
import { ReleaseFormComponent } from './admin/e-services/long-haul/release-form/release-form.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MeasurementFirstReviewerComponent } from './admin/e-services/long-haul/refund-request/measurement-first-reviewer/measurement-first-reviewer.component';
import { FirstReviewerComponent } from './admin/e-services/long-haul/restudy-request/first-reviewer/first-reviewer.component';
import { MeasurementManagerComponent } from './admin/e-services/long-haul/refund-request/measurement-manager/measurement-manager.component';
import { RestudyMeasurementManagerComponent } from './admin/e-services/long-haul/restudy-request/Restudy-Measurement-Manager/measurement-Manager.component';
import { RestudyEconomicComponent } from './admin/e-services/long-haul/restudy-request/Restudy-economic/Restudy-economic.component';
import { RestudyEconomicManagerComponent } from './admin/e-services/long-haul/restudy-request/Restudy-economic-Manager/Restudy-economic-manager.component';
import { RestudyNotifyCreatorComponent } from './admin/e-services/long-haul/restudy-request/Restudy-NotifyCreator/Restudy-NotifyCreator.component';
import { RestudyCancelRebateComponent } from './admin/e-services/long-haul/restudy-request/Restudy-CancelRebate/Restudy-CancelRebate.component';
import { MeasurementSecondReviewerComponent } from './admin/e-services/long-haul/refund-request/measurement-second-reviewer/measurement-second-reviewer.component';
import { DeputyManagerApprovalComponent } from './admin/e-services/long-haul/refund-request/deputy-manager-approval/deputy-manager-approval.component';
import { ManagerApprovalComponent } from './admin/e-services/long-haul/refund-request/manager-approval/manager-approval.component';
import { MeasurementPrintComponent } from './admin/e-services/long-haul/refund-request/measurement-print/measurement-print.component';
import { EunitApprovalComponent } from './admin/e-services/long-haul/refund-request/eunit-approval/eunit-approval.component';
import { RefundRequestComponent } from './admin/e-services/long-haul/refund-request/refund-request/refund-request.component';
import { ReleaseReportComponent } from './admin/e-services/long-haul/release-report/release-report.component';
import { RestudyRequestComponent } from './admin/e-services/long-haul/restudy-request/restudy-request/restudy-request.component';
import { ReleaseWFSubmittedAdminsComponent } from './admin/e-services/long-haul/release-wf-submitted-admins/release-wf-submitted-admins.component';
import { ConfirmVesselEntranceComponent } from './admin/e-services/e-booking/transit-request/confirm-vessel-entrance/confirm-vessel-entrance.component';
import { TransitIssueResolutionComponent } from './front-user/services/e-booking/transit-issue-resolution/transit-issue-resolution.component';
import { GuaranteeDeductionLettersComponent } from './front-user/services/e-booking/guarantee-deduction-letters/guarantee-deduction-letters.component';
import { ConfirmFeesPaymentComponent } from './admin/e-services/e-booking/transit-request/confirm-fees-payment/confirm-fees-payment.component';
import { RefundPaymentComponent } from './admin/e-services/e-booking/transit-request/refund-payment/refund-payment.component';
import { NavigationDecisionComponent } from './admin/e-services/e-booking/transit-request/navigation-decision/navigation-decision.component';
import { ImposeTugBoatsComponent } from './admin/e-services/e-booking/transit-request/impose-tug-boats/impose-tug-boats.component';
// import { FileValueAccessorDirective } from './shared/directives/FileAccessor';
import { MarineEstimatePenaltyComponent } from './admin/e-services/e-booking/transit-request/marine-estimate-penalty/marine-estimate-penalty.component';
import { NavigationConfirmPenaltyComponent } from './admin/e-services/e-booking/transit-request/navigation-confirm-penalty/navigation-confirm-penalty.component';
import { PenaltyFinanaceNotificationComponent } from './admin/e-services/e-booking/transit-request/penalty-finance-notification/penalty-finance-notification.component';
import { PenaltyMarineNotificationComponent } from './admin/e-services/e-booking/transit-request/penalty-marine-notification/penalty-marine-notification.component';
import { confirmVesselTransitComponent } from './admin/e-services/e-booking/transit-request/confirm-Vessel-Transit/confirm-Vessel-Transit.component';
import { EbookingTasksComponent } from './shared/components/ebooking-tasks/ebooking-tasks.component';


export function HttpLoaderFactory(http: HttpClient) {
  //   if (environment.name == "dev")
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');

       return new TranslateHttpLoader(http, AppConfig.settings.apiServer.spTarnsUrl, '.json');
}

export function getDatepickerConfig(): BsDatepickerConfig {
    return Object.assign(new BsDatepickerConfig(), {
        dateInputFormat: 'YYYY-MM-DD',
        containerClass: 'theme-dark-blue',
        minDate: new Date(),
        adaptivePosition: true,
        showWeekNumbers: false
    });
}

export function initializeApp(appConfig: AppConfig) {
    return () => appConfig.load();
}

@NgModule({
    declarations: [
        AppComponent,
        RegisterComponent,
        AlertComponent,
        LoginComponent,
        UserProfileComponent,
        WorkspaceComponent,
        SignOutComponent,
        ResetPasswordComponent,
        CircularsConfirmCancelComponent,
        ChangePasswordComponent,
        CircularsCancelRequestComponent,
        ForgetPasswordComponent,
        RebateRequestComponent,
        CreateRepairRequestComponent,
        SalvageRequestComponent,
        CreateFloatingCranesRequestComponent,
        AgentRegistrationComponent,
        StyleGuideComponent,
        MarineOfficerReviewComponent,
        MarineOfficerconfirmationComponent,
        AgentApprovalLimittimeRateComponent,
        SupplierRegistrationComponent,
        NonDestructiveTestingWorkComponent,
        DynamicBalancingRequestComponent,
        UserRequestDetailsComponent,
        AgentBasicInfoComponent,
        CreateHardnessTestRequestComponent,
        GridViewComponent,
        TestComponent,
        confirmVesselTransitComponent,
        AdminDecisionComponent,
        AdditionalWorkComponent,
        FeesEstimationRequestComponent,
        FibberglassRequestComponent,
        MyTasksComponent,
        ReleaseTasksComponent,
        MyRequestsComponent,
        MyRequestsWithVesselNameComponent,
        RequestHistoryComponent,
        MessageComponent,
        MyMessagesComponent,
        MyUnreadMessagesComponent,
        AllMessagesComponent,
        ETenderMessagesComponent,
        ConfirmAccountComponent,
        ActivateAccountComponent,
        WorkCompletionFormComponent,
        RegistrationAdminDecisionComponent,
        FibberglassContractComponent,
        FibberglassOfflinePaymentComponent,
        InvalidForgetpasswordLinkComponent,
        ConfimPaymentComponent,
        ReleaseFormComponent,
        RequestDetailsComponent,
        UserDecisionComponent,
        AllServicesComponent,
        EnterEachCurrencyComponent,
        OfflineAgentRegistrationComponent,
        RebateRequestConfirmReceivingRequestComponent,
        RebateRequestDefineRebateComponent,
        RebateRequestMeasurementCommitteeDecisionComponent,
        CircularRequestAdminDecisionComponent,
        MeasurementsReviewerDecisionComponent,
        MeasurementOfficerFeesComponent,
        MeasurementOfficerFeesComponentNew,
        MarineOfficerFeesComponent,
        ManagerConfirmFeesComponent,
        ManagerConfirmFeesComponentNew,
        UpdateAgentProfileComponent,
        RegisterAdminDecisionComponent,
        EnterTreasuryNumbersComponent,
        EbookingAccurateDataComponent,
        RebateRequestReviewRebateComponent,
        CircularsCancelRequestComponent,
        CircularsConfirmCancelComponent,
        UnauthorizedUserComponent,
        OfflineAgentListComponent,
        ActivateAgentComponent,
        DeacitvateAgentComponent,
        ActivateAgentRepresentativeComponent,
        DeactivateAgentRepresentativeComponent,
        AgentRepresentativeListComponent,
        RebateRequestFormulatdDecisionComponent,
        ShipyardReportComponent,
        ActivateAgentWithDeactivationDateComponent,
        SupplierBidSubsriptionComponent,
        EBookingReportComponent,
        RebateRequestRequestorDecisionComponent,
        CircularRequestRequestorDecisionComponent,
        BidSupplierSubscriptionListComponent,
        FeesEstimationDetailsComponent,
        TransitRequestComponent,
        AccurateDataFormComponent,
        ChangeRebateFormComponent,
        ConfirmShipPassingComponent,
        MarkRequestRefundedComponent,
        MarineAcceptTransitDateComponent,
        EtenderEvaluationComponent,
        SupplierListComponent,
        CreateTenderComponent,
        ViewTenderComponent,
        TenderListComponent,
        RebateRequestsManagementComponent,
        RebateRequestRequestDetailsComponent,
        CircularRequestBaseRequestDetailsComponent,
        MarineMarkVesselArrivedComponent,
        TreasuryConfirmFirstPaymentComponent,
        MarineEstimatePenaltyComponent,
        NavigationConfirmPenaltyComponent,
        PenaltyFinanaceNotificationComponent,
        PenaltyMarineNotificationComponent,
        MeasurementExtraFeesComponent,
        TreasuryConfirmFinalPaymentComponent,
        MeasurementConfirmPendingDocumentsComponent,
        RebateRequestBaseRequestDetailsComponent,
        DeactivateSupplierComponent,
        OnlyDecimalDirective,
        FileValidator,
        CancelTenderComponent,
        DeleteTenderComponent,
        DefineTenderDeadlineComponent,
        FileValueAccessor,
        SupplierRatingComponent,
        EtenderSupplierEvaluationListComponent,
        SupplierRegistrationAprovalComponent,
        PurchasingCategoryAdminAprovalComponent,
        TechnicalCategoryAdminAprovalComponent,
        SupplierRegistrationActivateComponent,
        SupplierTenderListComponent,
        TenderComponent,
        LongHaulReportComponent,
        RebateRequestCloneRequestComponent,
        CircularRequestCloneRequestComponent,
        ConfirmationDirective,
        TenderViewAllFieldsComponent,
        // FileValueAccessorDirective,
        ActivateAgentTreasuryNumbersComponent,
        InviteAdditionalSupplierComponent,
        EntranceRequestComponent,
        SmallUnitsReviewRequestComponent,
        MeasurementEstimateFeesComponent,
        ConfirmArrivalComponent,
        RegisterMeasurmentComponent,
        ConfirmPaymentComponent,
        SmallUnitsConfirmDocumentComponent,
        SmallUnitsTransitRequestComponent,
        ReviewTransitRequestComponent,
        TransitApprovalComponent,
        ConfirmTransitComponent,
        FinalFeesComponent,
        SmallUnitsTasksComponent,
        CircularRequestComponent,
        CircularTasksDirectoryComponent,
        CircularsTasksComponent,
        ChangeCrewTasksComponent,
        SmallUnitsReportComponent,
        CrewChangeReportComponent,
        CircularsReportsComponent,
        CircularsConfirmShipPassingComponent,
        CircularsRefundCloseComponent,
        CicularRequestorrejectionNotificationComponent,
        CircularRequestDetailsComponent,
        IsmConfirmArrivalComponent,
        IsmRequestDepartureComponent,
        IsmDepartureApprovalComponent,
        IsmConfirmTransitComponent,
        CrewChangeRequestComponent,
        CrewchangeReviewerDecisionComponent,
        CrewchangeApprovalDecisionComponent,
        CrewChangeAgentApprovalComponent,
        MeasurementFirstReviewerComponent,
        FirstReviewerComponent,
        MeasurementSecondReviewerComponent,
        MeasurementManagerComponent,
        RestudyMeasurementManagerComponent,
        RestudyEconomicComponent,
        RestudyEconomicManagerComponent,
        EunitApprovalComponent,
        DeputyManagerApprovalComponent,
        ManagerApprovalComponent,
        MeasurementPrintComponent,
        RefundRequestComponent,
        ReleaseReportComponent,
        RestudyRequestComponent,
        ReleaseWFSubmittedAdminsComponent,
        RestudyNotifyCreatorComponent,
        RestudyCancelRebateComponent,
        ConfirmVesselEntranceComponent,
        TransitIssueResolutionComponent,
        GuaranteeDeductionLettersComponent,
        ConfirmFeesPaymentComponent,
        RefundPaymentComponent,
        NavigationDecisionComponent,
        ImposeTugBoatsComponent,
        EbookingTasksComponent
    ],
    imports: [
        BrowserModule,
        AutocompleteLibModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        BsDropdownModule.forRoot(),
        ToastrModule.forRoot(),
        NgxCaptchaModule,
        TimepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        TranslateModule.forRoot({
            useDefaultLang: true, isolate: false,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BsDatepickerModule.forRoot(),
        TabsModule.forRoot(),
        NgbModule
        //Ng2BootstrapModule,
        //Ng2TableModule
    ],
    providers: [
        CookieService,
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppConfig], multi: true
        },
        { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
        DatePipe
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
